import { RuleType } from "components/ContractLanguageSection/types";

import { api } from ".";

export interface IAppliedRuleAttachment {
  id: string;
  fileName: string;
  fileSize: number;
  createdAt: string;
}

export interface IAppliedRule {
  ruleType: RuleType;
  ruleId: string;
  ruleName: string;
  contractLanguage: string | null;
  attachments: IAppliedRuleAttachment[];
}

export interface IClaimAppliedRulesResponse {
  data: IAppliedRule[];
}

const claimAppliedRulesQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getClaimAppliedRules: builder.query<IClaimAppliedRulesResponse, string>({
      query: (claimId) => `claims/${claimId}/applied-rules`,
      providesTags: (_r, _e, claimId) => [
        { type: "Claims", id: `applied-rules-${claimId}` },
      ],
    }),
  }),
});

export const { useGetClaimAppliedRulesQuery } = claimAppliedRulesQueries;
